function moverBadgeTimesact(badge) {
  const productCard = badge.closest('.product-card');
  if (productCard) {
    const cardMedia = productCard.querySelector('.product-card__media');
    if (!cardMedia) return;
    cardMedia.style.position = 'relative';
    cardMedia.style.overflow = 'hidden';
    if (badge.parentElement !== cardMedia) {
      cardMedia.appendChild(badge);
    }
    badge.style.removeProperty('left');
    badge.style.removeProperty('right');
    badge.style.removeProperty('bottom');
    badge.style.removeProperty('top');
    badge.style.removeProperty('transform');
    badge.style.removeProperty('position');
    badge.style.removeProperty('z-index');
    badge.style.removeProperty('display');
    badge.style.removeProperty('flex-wrap');
    badge.style.removeProperty('width');
    badge.style.setProperty('position', 'absolute', 'important');
    badge.style.setProperty('bottom', '10px', 'important');
    badge.style.setProperty('left', '50%', 'important');
    badge.style.setProperty('transform', 'translateX(-50%)', 'important');
    badge.style.setProperty('top', 'auto', 'important');
    badge.style.setProperty('z-index', '10', 'important');
    badge.style.setProperty('width', 'auto', 'important');
    badge.style.setProperty('max-width', '90%', 'important');
    return;
  }

  const primeraImagen = document.querySelector('.product-gallery__media');
  if (primeraImagen) {
    primeraImagen.style.position = 'relative';
    primeraImagen.style.overflow = 'hidden';
    if (badge.parentElement !== primeraImagen) {
      primeraImagen.appendChild(badge);
    }
    badge.style.removeProperty('left');
    badge.style.removeProperty('right');
    badge.style.removeProperty('bottom');
    badge.style.removeProperty('top');
    badge.style.removeProperty('transform');
    badge.style.removeProperty('position');
    badge.style.removeProperty('z-index');
    badge.style.removeProperty('display');
    badge.style.removeProperty('flex-wrap');
    badge.style.removeProperty('width');
    badge.style.setProperty('position', 'absolute', 'important');
    badge.style.setProperty('bottom', '10px', 'important');
    badge.style.setProperty('left', '50%', 'important');
    badge.style.setProperty('transform', 'translateX(-50%)', 'important');
    badge.style.setProperty('top', 'auto', 'important');
    badge.style.setProperty('z-index', '10', 'important');
    badge.style.setProperty('width', 'auto', 'important');
    badge.style.setProperty('max-width', '90%', 'important');
  }
}

function fixBotonTimesact(boton) {
  boton.style.removeProperty('border-radius');
  boton.style.removeProperty('width');
  boton.style.removeProperty('height');
  boton.style.removeProperty('background-color');
  boton.style.removeProperty('border');
  boton.style.removeProperty('border-color');
  boton.style.removeProperty('border-width');
  boton.style.removeProperty('color');
  boton.style.removeProperty('font-size');
}

function procesarTodo() {
  document.querySelectorAll('.timesact-badge-common-bis').forEach(moverBadgeTimesact);
  document.querySelectorAll('.timesact-button-bis').forEach(fixBotonTimesact);
}

const timesactObserver = new MutationObserver(function() {
  procesarTodo();
});

timesactObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', function() {
  procesarTodo();
  setTimeout(procesarTodo, 500);
  setTimeout(procesarTodo, 1500);
});

// Ocultar badge si el producto tiene stock real en Shopify
function verificarStockBadges() {
  const badges = document.querySelectorAll('.timesact-badge-common-bis');
  badges.forEach(function(badge) {
    const link = badge.closest('a.product-card__media');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    const handle = href.replace('/products/', '').split('?')[0];
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function(res) { return res.json(); })
      .then(function(product) {
        const tieneStock = product.variants.some(function(v) {
          return v.available === true;
        });
        if (tieneStock) {
          badge.style.setProperty('display', 'none', 'important');
        }
      })
      .catch(function() {});
  });
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(verificarStockBadges, 2000);
  setTimeout(verificarStockBadges, 4000);
});


function ocultarBadgeAgotado() {
  document.querySelectorAll('sold-out-badge, .badge--sold-out').forEach(function(el) {
    el.style.setProperty('display', 'none', 'important');
  });
}

document.addEventListener('DOMContentLoaded', function() {
  ocultarBadgeAgotado();
  setTimeout(ocultarBadgeAgotado, 500);
  setTimeout(ocultarBadgeAgotado, 1500);
});